import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./main-prescription.scss"
import Medicine from './medicine/medicine'
import LabTest from './labtest/labtest'
import Advice from './advice/advice'
import MasterDataManager from '../master-data-manager/master-data-manager'
import { useDispatch } from 'react-redux'
import { put } from '../../../utils/fetchAPI'

const MainPrescription = ({ patientId, visitId, appointmentId, visitDetails, refresh, updateState }) => {
    const dispatch = useDispatch();
    const [nextVisit, setNextVisit] = useState("")
    const timeoutIdRef = useRef(null)


    useEffect(() => {
        if (visitDetails?.nextVisitInstruction) {
            setNextVisit(visitDetails?.nextVisitInstruction)
        }
    })

    const instructionSetTime = (event) => {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { giveNextVisitInstruction(event.target.value) }, 700);
    };

    const giveNextVisitInstruction = (value) => {
        put(`/visit/${visitDetails?._id}`, { "nextVisitInstruction": value })
            .then((res) => {
                if (res.status === 200) {
                    //updateState(res?.data)
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    }

    return (
        <div className='prescription-full-body'>
            <div className='medicine-section'>
                <Medicine updateState={updateState} visitDetails={visitDetails} patientId={patientId} visitId={visitId}></Medicine>
            </div>
            <div className='labTest-advice-section-1'>
                <div className='lab-test'>
                    <div className='sub-section-head'>
                        Investigation
                        <MasterDataManager entity="labTest" doctorId={visitDetails?.doctor}></MasterDataManager>
                        {visitDetails?.labTests?.length > 0 && <span className='sub-badge'>{visitDetails.labTests.length}</span>}
                    </div>
                    <div className='sub-section-search'>
                        <LabTest updateState={updateState} visitDetails={visitDetails}></LabTest>
                    </div>
                </div>
                <div className='advice-col'>
                    <div className='sub-section-head'>
                        Advice
                        <MasterDataManager entity="advice" doctorId={visitDetails?.doctor}></MasterDataManager>
                        {visitDetails?.advices?.length > 0 && <span className='sub-badge'>{visitDetails.advices.length}</span>}
                    </div>
                    <div className='sub-section-search'>
                        <Advice updateState={updateState} visitDetails={visitDetails}></Advice>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainPrescription
